import RestApiModel from "@/api/Model/RestApiModel";

class ChartInfo extends RestApiModel {
  static getResourceEndpoint() {
    return '/ChartInfoTwo';
  }
}

export default ChartInfo;
